import PropTypes from 'prop-types';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { required } from 'apex-web/lib/helpers/formValidations';
import APInput from 'apex-web/lib/components/common/APInput';
import APCryptoAddressInput from 'apex-web/lib/components/common/APCryptoAddressInput/APCryptoAddressInputContainer';
import APButton from 'apex-web/lib/components/common/APButton';
import APCheckbox from 'apex-web/lib/components/common/APCheckbox';
import './WhiteListAddressForm.css';

const bemClasses = getBEMClasses('whitelist-address-form');

const WhiteListAddressForm = (props, context) => {
  const { invalid, submitting, ProductSymbol, handleSubmit } = props;

  return (
    <form onSubmit={handleSubmit}>
      <p
        className={bemClasses('label-text')}
        style={{ marginBottom: '1.4rem' }}>
        {context.t('Add an address to the whitelist')}
      </p>

      <p className={bemClasses('label-text')}>{context.t('Name')}</p>
      <APInput
        name="Name"
        label="Name"
        customClass={getBEMClasses('send-form')()}
        validate={[required]}
      />

      <p className={bemClasses('label-text')}>{context.t('Address')}</p>
      <APCryptoAddressInput
        productSymbol={ProductSymbol}
        name="AccountIdentifier"
        customClass={getBEMClasses('send-form')()}
        label="Address"
      />

      <APCheckbox
        name="OwnAddress"
        label="It's my own address"
        id="own-address"
        validate={[required]}
      />

      <APButton
        type="submit"
        customClass={getBEMClasses('send-form')()}
        styleName="additive"
        disabled={invalid || submitting}>
        {context.t('Add to Whitelist')}
      </APButton>
    </form>
  );
};

WhiteListAddressForm.contextTypes = {
  t: PropTypes.func.isRequired
};

export default WhiteListAddressForm;
